var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFactory = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "M11.4 22.5H1.2V8.6h1v12.9h9.2zM15.5 9.1H8.8c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h6.7c.3 0 .5.2.5.5s-.2.5-.5.5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "M8.8 19.5c-.3 0-.5-.2-.5-.5V4.5H2.2v7.4c0 .3-.2.5-.5.5s-.5-.2-.5-.5V4.4c0-.5.4-.9.9-.9h6.4c.5 0 .9.4.9.9V19c-.1.3-.3.5-.6.5M15.7 19.5c-.3 0-.5-.2-.5-.5V8.6c0-.3.2-.5.5-.5s.5.2.5.5V19c0 .3-.2.5-.5.5"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#129BF9",
  d: "M20.1 18.4c-.1 0-.2 0-.3-.1-.2-.2-.3-.5-.1-.7l3.8-5.9-5 .6c-.3 0-.5-.1-.7-.3s-.1-.5 0-.8l4.1-6.4c.1-.2.5-.3.7-.2s.3.5.2.7L19 11.4l5-.6c.3 0 .5.1.7.3s.1.5 0 .8l-4.2 6.4c-.1 0-.2.1-.4.1"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "M3.3 6.8h4v1h-4zM10.4 11.6h3.7v1h-3.7zM19.7 19h1v.5h-1zM19.7 20.2h1v.7h-1zM19.7 21.5h1v1h-1zM18.6 22.5h-1.1v-1h1.1zm-2.2 0h-1.1v-1h1.1zm-2.3 0H13v-1h1.1zM11.4 21.5h.5v1h-.5z"
})));
export default SvgFactory;